// extracted by mini-css-extract-plugin
export default {"buyButton":"wYDXf","hasInCart":"Uj9ns","iconCheck":"XP3co"};